<template>
  <div>
    <div class="container">
      <div class="router_view">
        <keep-alive>
          <router-view v-if='$route.meta.keepAlive' />
        </keep-alive>
        <router-view v-if='!$route.meta.keepAlive' />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  box-sizing: border-box;
}
.router_view {
  width: 100%;
  margin-top: 50px;
  min-height: calc(100vh - 180px);
  border-radius: 5px;
}
</style>